import { Any, Arr } from "@kizmann/pico-js";
import LoginService from "#pub/service/LoginService.js";

export default {

    name: 'AppLogin',

    data()
    {
        return {
            mode: 0, load: false, email: '', password: '', codehash: ''
        };
    },

    methods: {

        next(mode = null)
        {
            if ( mode !== null ) {
                this.mode = mode;
            }

            if ( this.mode === 0 ) {
                return this.postLogin();
            }

            if ( this.mode === 1 ) {
                return this.postCodehash();
            }

            this.$root.runInitCalls();
        },

        postLogin()
        {
            let body = {
                email: this.email,
                password: this.password
            };

            let config = {
                onLoad: () => this.load = true,
                onDone: () => this.load = false,
            }

            LoginService.postLogin(body, config)
                .then(({data}) => {
                    Any.isEmpty(data.cookies) ? this.mode = 1 : this.next(2);
                })
                .catch(() => {
                    this.mode = 0;
                });
        },

        postCodehash()
        {
            let body = {
                email: this.email,
                password: this.password,
                codehash: this.codehash
            };

            let config = {
                onLoad: () => this.load = true,
                onDone: () => this.load = false,
            }

            LoginService.postCodehash(body, config)
                .then(() => {
                    this.next(2);
                })
                .catch(() => {
                    this.mode = 0;
                });
        }

    },

    renderUsername()
    {
        if ( this.mode !== 0 ) {
            return null;
        }

        let inputProps = {
            name: 'email',
            placeholder: this.trans('Enter email')
        };

        inputProps['onKeydown'] = (e) => {
            if ( e.keyCode === 13 ) {
                this.postLogin();
            }
        };

        return (
            <div class="app-login__email col-1-1">
                <NInput vModel={this.email} {...inputProps} />
            </div>
        );
    },

    renderPassword()
    {
        if ( this.mode !== 0 ) {
            return null;
        }

        let inputProps = {
            name: 'password',
            nativeType: 'password',
            placeholder: this.trans('Enter password')
        };

        inputProps['onKeydown'] = (e) => {
            if ( e.keyCode === 13 ) {
                this.postLogin();
            }
        };

        return (
            <div class="app-login__password col-1-1">
                <NInput vModel={this.password} {...inputProps} />
            </div>
        );
    },

    renderCodehash()
    {
        if ( this.mode !== 1 ) {
            return null;
        }

        let inputProps = {
            placeholder: this.trans('Enter codehash')
        };

        inputProps['onKeydown'] = (e) => {
            if ( e.keyCode === 13 ) {
                this.postCodehash();
            }
        };

        return (
            <div class="app-login__codehash col-1-1">
                <NInput vModel={this.codehash} {...inputProps} />
            </div>
        );
    },

    renderSubmit()
    {
        if ( this.mode === 2 ) {
            return null;
        }

        let buttonProps = {
            glass: true, icon: 'fa fa-unlock'
        };

        buttonProps['onPointerdown'] = (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.next();
        };

        return (
            <div class="app-login__submit col-1-1">
                <NButton {...buttonProps}>{this.trans('Login')}</NButton>
            </div>
        );
    },

    renderWaiting()
    {
        if ( this.mode !== 2 ) {
            return null;
        }

        return (
            <div class="app-load">
                <span>{this.trans('Waiting for status check ...')}</span>
            </div>
        );
    },

    render()
    {
        let ctors = [
            'renderUsername',
            'renderPassword',
            'renderCodehash',
            'renderSubmit',
            'renderWaiting',
        ];

        return (
            <NLoader visible={this.load} class="app-login">
                <NForm form={this.$data} dom={'form'}>
                    <div class="n-grid column gap-10">
                        {Arr.each(ctors, (fx) => this.ctor(fx)())}
                    </div>
                </NForm>
            </NLoader>
        )
    }
}